import {Aluno} from "./aluno";
import {AcaoExecutada} from "./acao-executada";

export class FrequenciaAcao {

    id: number;
    aluno: Aluno;
    justificativa: string;
    situacao: string;
    idUsuario: number;

}